// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__17EWA","footer":"ModalInfo_footer__1eJ0R"};